import React from 'react'
import { cn } from '../../../../utils';

export default function MovingCircle({ variant='white',className }) {

  return (
    <div
      className={cn(
        'loader h-4 w-4 rounded-full border-t-4 border-l-4 border-r-4 ',
        variant === 'white'
          ? 'border-t-white border-l-white border-r-black'
          : 'border-t-black border-l-black border-r-white',
        className
      )}
    ></div>
  );
}
